import { courseHelpers } from 'Components/Card/Partials/Partials.Course';
import voucherHelpers from 'Components/Card/helper/voucherHelpers';

const tutorSessionHelpers = {
    cardLinkBtnClass: courseHelpers.cardLinkBtnClass,
    showVoucher: (sessions) => voucherHelpers.VoucherExpiresWithin30Days(sessions.VoucherExpirationDate),
    showEvent: (sessions) => sessions.HasUpcomingSession,
    showSchedule: (sessions) => !sessions.HasUpcomingSession && !tutorSessionHelpers.isComplete(sessions),
    isComplete: (sessions) => sessions.VoucherCount && sessions.VoucherRedeemedCount && sessions.VoucherCount === sessions.VoucherRedeemedCount && !sessions.HasUpcomingSession,
    showComponent: (sessions) => !tutorSessionHelpers.isComplete(sessions) && sessions.hasCourse,
    getShowProperties: (sessions) => ({
        showVoucher: tutorSessionHelpers.showVoucher(sessions),
        showEvent: tutorSessionHelpers.showEvent(sessions),
        showSchedule: tutorSessionHelpers.showSchedule(sessions),
        isComplete: tutorSessionHelpers.isComplete(sessions),
        showComponent: tutorSessionHelpers.showComponent(sessions)
    })
};

export default tutorSessionHelpers;